module.exports = __webpack_public_path__ + "static/tdoaa-6582607eb87826a69989d35c30727caa.jpg";